export default __webpack_public_path__ + "static/media/AxisTextLogo.ba0e98e1.png";